// @ts-nocheck
import { GetTrailerTrackingsV2ApiParameter } from "@store/Framework/Services/TrailerServiceV2";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetTrailerTrackingsV2ApiParameter>;

export const DispatchUpdateDraftParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/UpdateDraftParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateDraftParameter];

const updateDraftParameter = createHandlerChainRunner(chain, "UpdateDraftParameter");
export default updateDraftParameter;
